//@ts-nocheck
import { getConfig } from "../config/config";
import { formatDate, formateDateForGetTimeScaleMarks } from "../helpers";
const { APP_BASE_APIHUB_API_URL } = getConfig();
function getDate(dateString) {
    if (dateString != undefined) {
        var dateObject;
        if (dateString instanceof Date) {
            dateObject = dateString;
        }
        else {
            dateObject = new Date(dateString.replace(/-/g, "/"));
        }
        return dateObject;
    }
    return null;
}
export const fetchCorporateActionData = async (symbolInfo, startDate, endDate) => {
    let fullString = symbolInfo.ticker;
    let parts = fullString.split(":");
    let exchParam = parts[0];
    let symbolDesc = parts[1].split("/")[0];
    let scripCodePart = parts[1].split("/")[1].split("-")[0];
    async function getCoCode() {
        var _a;
        let url;
        if (exchParam.toLowerCase() === "nse") {
            url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Equity/Market.svc/MultiIndexGetCodes/nse/?symbol=${symbolDesc}&responsetype=json`;
        }
        else {
            url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Equity/Market.svc/MultiIndexGetCodes/bse/?bsecode=${scripCodePart}&responsetype=json`;
        }
        try {
            const response = await fetch(url, {
                method: "GET",
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const api_response = await response.json();
            // Check if response has the expected structure and co_code exists
            if (api_response.response &&
                api_response.response.data &&
                api_response.response.data.multiindexlist &&
                api_response.response.data.multiindexlist.multiindex) {
                const companyDetails = api_response.response.data.multiindexlist.multiindex;
                // Ensure companyDetails array or object contains the co_code
                if (Array.isArray(companyDetails)) {
                    return ((_a = companyDetails[2]) === null || _a === void 0 ? void 0 : _a.co_code) || null; // Use optional chaining to avoid accessing undefined
                }
                else {
                    return companyDetails.co_code || null; // Fallback for when it's not an array
                }
            }
            else {
                return null;
            }
        }
        catch (err) {
            console.error("Fetch error:", err);
            return null;
        }
    }
    const symbol_co_code = await getCoCode();
    if (!symbol_co_code) {
        return []; // Return empty array as a fallback
    }
    let date = new Date(startDate * 1000);
    let formattedFromDate = date.toISOString().split("T")[0];
    let date1 = new Date(endDate * 1000);
    let formattedToDate = date1.toISOString().split("T")[0];
    let api_url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Equity/Market.svc/AllCorporateActionData/${symbol_co_code}/${formattedFromDate}/${formattedToDate}?responsetype=json`;
    try {
        const searchRequest = await fetch(api_url, {
            method: "GET",
        });
        const responseData = await searchRequest.json();
        // Check if the expected data structure exists
        if (responseData.response &&
            responseData.response.data &&
            responseData.response.data.AllCorporateActionDataList &&
            responseData.response.data.AllCorporateActionDataList
                .AllCorporateActionData) {
            let corporateActions = responseData.response.data.AllCorporateActionDataList
                .AllCorporateActionData;
            if (!Array.isArray(corporateActions)) {
                corporateActions = [corporateActions]; // Ensure it's an array
            }
            let marks = [];
            corporateActions.forEach((data) => {
                let tempObj = {};
                let formatedDateOfApi = formateDateForGetTimeScaleMarks(data.exdate);
                let utcDate = new Date(getDate(formatedDateOfApi)).getTime() / 1000;
                let formattedExDate = formatDate(data.exdate);
                let formattedAnnouncementDate = formatDate(data.announcementdate);
                switch (data.purpose) {
                    case "Dividend":
                        tempObj.id = Math.random().toString().substr(2, 2);
                        tempObj.time = utcDate;
                        tempObj.color = "Green";
                        tempObj.label = "D";
                        tempObj.tooltip = [
                            data.purpose,
                            "Dividend Amount Per share :" + (data.divamount || 0),
                            "Announcement Date :" + formattedAnnouncementDate,
                            "Ex-Date :" + formattedExDate,
                        ];
                        marks.push(tempObj);
                        break;
                    case "Bonus":
                        tempObj.id = Math.random().toString().substr(2, 2);
                        tempObj.time = utcDate;
                        tempObj.color = "Red";
                        tempObj.label = "B";
                        tempObj.tooltip = [
                            data.purpose,
                            "Bonus ratio :" + (data.bonusratio || "N/A"),
                            "Announcement Date :" + formattedAnnouncementDate,
                            "Ex-Date :" + formattedExDate,
                        ];
                        marks.push(tempObj);
                        break;
                    case "Rights":
                        tempObj.id = Math.random().toString().substr(2, 2);
                        tempObj.time = utcDate;
                        tempObj.color = "Blue";
                        tempObj.label = "R";
                        tempObj.tooltip = [
                            data.purpose,
                            "Right ratio :" + (data.rightsratio || "N/A"),
                            "Announcement Date :" + formattedAnnouncementDate,
                            "Ex-Date :" + formattedExDate,
                        ];
                        marks.push(tempObj);
                        break;
                    case "Split":
                        tempObj.id = Math.random().toString().substr(2, 2);
                        tempObj.time = utcDate;
                        tempObj.color = "Yellow";
                        tempObj.label = "S";
                        tempObj.tooltip = [
                            data.purpose,
                            "Split = " + data.fvbefore + "/" + data.fvafter || "N/A",
                            "Announcement Date :" + formattedAnnouncementDate,
                            "Ex-Date :" + formattedExDate,
                        ];
                        marks.push(tempObj);
                        break;
                }
            });
            return marks;
        }
    }
    catch (error) {
        console.error("Error fetching corporate action data:", error);
        return [];
    }
};
